import React from 'react';
import { Col, Row } from 'react-bootstrap';

const ComentarioSkeleton = () => (
    <Row className="g-2 p-2">
        {[1, 2, 3, 4, 5].map((i) => (
            <Col key={i} xs={12}>
                <div style={{
                    padding: "12px",
                    border: "1px solid #e3e3e3",
                    borderRadius: "8px",
                    background: "transparent"
                }}>
                    <div className="mb-2">
                        <span className="bg-light rounded-2 me-2" style={{ height: 14, width: 100, display: "inline-block" }} />
                        <span className="bg-light rounded-2 me-2" style={{ height: 14, width: 80, display: "inline-block" }} />
                        <span className="bg-light rounded-2" style={{ height: 14, width: 60, display: "inline-block" }} />
                    </div>
                    <div className="mb-2">
                        <span className="bg-light rounded-2" style={{ height: 16, width: "90%", display: "block" }} />
                    </div>
                    <div>
                        <span className="bg-light rounded-2" style={{ height: 16, width: "80%", display: "block" }} />
                    </div>
                </div>
            </Col>
        ))}
    </Row>
);

export default ComentarioSkeleton;
